export default {
  items: [
    // {
    //   name: 'Dashboard',
    //   url: '/dashboard',
    //   icon: 'icon-speedometer'
    //   // badge: {
    //   //   variant: 'info',
    //   //   text: 'NEW'
    //   // }
    // },
    {
      name: 'Add Business',
      url: '/add-business',
      icon: 'fa fa-plus',
    },
    {
      name: 'Business Claims',
      url: '/business-claims',
      icon: 'icon-briefcase',
    },
    {
      name: 'Forms',
      url: '/forms',
      icon: 'icon-info',
    },
    {
      name: 'Business Categories',
      url: '/categories',
      icon: 'icon-folder-alt',
    },
    {
      name: 'Category Groups',

      icon: 'icon-folder',
      children: [
        {
          name: 'View Groups',
          url: '/category-groups',
          icon: 'icon-magnifier',
        },
        {
          name: 'Create Group',
          url: '/category-groups/create',
          icon: 'icon-plus',
        },
      ],
    },
    {
      name: 'Search Businesses',
      url: '/search-businesses',
      icon: 'icon-magnifier',
    },
    {
      name: 'Powered Pending',
      url: '/powered-pending',
      icon: 'fa fa-check',
    },
    {
      name: 'Powered Images',
      url: '/powered-images',
      icon: 'fa fa-bolt',
    },
    {
      name: 'Copy Inventory',
      url: '/copy-inventory',
      icon: 'icon-docs',
    },
    {
      name: 'Delete Requests',
      url: '/delete-requests',
      icon: 'icon-trash',
    },
    {
      name: 'Geofences',
      url: 'geofences',
      icon: 'icon-globe',
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-people',
    },
    {
      name: 'Flagged Items',
      url: '/flags',
      icon: 'icon-flag',
    },
    {
      name: 'Partnership',
      icon: 'fa fa-handshake-o',
      children: [
        {
          name: 'Create Partner',
          url: '/partnership/create',
          icon: 'fa fa-plus',
        },
        {
          name: 'View Partners',
          url: '/partnership/view-partners',
          icon: 'icon-magnifier',
        },
      ],
    },
    {
      name: 'Admin Routes',
      url: '/admin-routes',
      icon: 'fa fa-lock',
    },
    {
      name: 'Create User',
      url: '/create-user',
      icon: 'fa fa-user-plus',
    },
    {
      name: 'GoNation TV',
      url: '/gonation-tv',
      icon: 'fa fa-tv',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js